import { render, staticRenderFns } from "./CArticleFilter.vue?vue&type=template&id=4a1a8bee&"
import script from "./CArticleFilter.vue?vue&type=script&lang=ts&"
export * from "./CArticleFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports